import MissionBalancesheetContent from "components/balancesheet/content/MissionBalancesheetContent";
import PersonMissionBalancesheetHeader from "components/balancesheet/header/PersonMissionBalancesheetHeader";
import Print from "components/Print";
import { Typography } from "core/typography/Typography";
import { createPdfFromHtml, waitForNextPaint } from "utils/logic";
import { useEffect, useRef, useState } from "react";
import { useMissionBalancesheetContext } from "api/balance-sheet/mission/MissionBalancesheetProvider";
import { useParams } from "react-router-dom";
import { useUserContext } from "api/user/UserProvider";
import { flushSync } from "react-dom";

const ConsultantMissionBalancesheet = () => {
  const { lang, userScope } = useUserContext();
  const dynamicTable = useRef([]);

  const { getMissionBalanceSheetWithSlugId, consultantMissionBalancesheet } =
    useMissionBalancesheetContext();
  const { missionId, evaluationId } = useParams();

  const [form, setForm] = useState({
    fields: [],
  });
  const [isExportingPdf, setIsExportingPdf] = useState(false);

  useEffect(() => {
    if (missionId && evaluationId) {
      getMissionBalanceSheetWithSlugId({ missionId, evaluationId });
    }
  }, []);

  const onClickExport = async () => {
    flushSync(() => {
      setIsExportingPdf(true);
    });

    try {
      await waitForNextPaint();

      await createPdfFromHtml({
        fileName: `bilan-mission-${consultantMissionBalancesheet?.worker_slug}`,
      });
    } finally {
      flushSync(() => {
        setIsExportingPdf(false);
      });
    }
  };

  return (
    <div className="balancsheet-section balancesheet-responsive-page">
      <PersonMissionBalancesheetHeader
        missionName={consultantMissionBalancesheet?.mission_name}
        clientName={consultantMissionBalancesheet?.client_name}
        clientSlug={consultantMissionBalancesheet?.client_slug}
        workerName={consultantMissionBalancesheet?.worker_name}
        workerSlug={consultantMissionBalancesheet?.worker_slug}
        userScope={userScope}
        onClickExport={onClickExport}
      />
      <Print>
        <Typography
          className="title-2 violet text-uppercase"
          type="h2"
          label={
            consultantMissionBalancesheet?.balancesheet?.template_title || ""
          }
        />
        <div className="separator-title"></div>
        <MissionBalancesheetContent
          data={consultantMissionBalancesheet}
          readOnly
          isExport={isExportingPdf}
          form={form}
          setForm={setForm}
          lang={lang}
          dynamicTable={dynamicTable}
        />
      </Print>
    </div>
  );
};

export default ConsultantMissionBalancesheet;
